// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__33Nic","inputWrap":"styles_inputWrap__25Qj9","input":"styles_input__1BLU8"};